import { Typography } from "@otp/ui";
import { useTranslation } from 'react-i18next';
import { UserLevelColumn } from 'src/components/common/table/columns/level';
import { User } from 'src/graphql/generated/graphql';
import {
  getFullName,
  getUserLevels,
  getUserPrograms,
} from 'src/utils/user-data';

export const UsernameEmail = ({
  user,
  options,
  className,
}: {
  user: Partial<User>;
  options?: {
    nameOnly?: boolean;
    withLevel?: boolean;
    withMcId?: boolean;
    withPrograms?: boolean;
    withOperatorName?: boolean;
  };
  className?: string;
}) => {
  const { t } = useTranslation();

  const { nameOnly, withLevel, withMcId, withPrograms, withOperatorName } =
    options || {};

  if (!user) {
    return null;
  }

  return (
    <div className={className}>
      <Typography
        fontWeight="bold"
        variant="subtitle1"
        component="div"
        className="flex flex-row items-center gap-1"
      >
        {getFullName(user)}
        {withMcId && (
          <Typography variant="subtitle2" component="div">
            {user.mcId}
          </Typography>
        )}
        {withLevel && (
          <div>
            {getUserLevels(user).map((level) => (
              <UserLevelColumn key={level} level={level} />
            ))}
          </div>
        )}
      </Typography>
      {withPrograms && (
        <Typography variant="subtitle2" component="div">
          {getUserPrograms(user).map((program) => program.name)}
        </Typography>
      )}
      {!nameOnly && (
        <Typography variant="subtitle2" component="div">
          {user.email}
        </Typography>
      )}
      {withOperatorName && user.operatorName && (
        <Typography variant="subtitle2" component="div">
          {t('common.operator-name')}: {user.operatorName}
        </Typography>
      )}
    </div>
  );
};
